"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Process() {
  const steps = [{
    number: "01",
    title: "AUDYT TECHNICZNY",
    description: "Wstępna wizja lokalna w celu oceny stanu technicznego dachu, identyfikacji miejsc przecieków oraz pomiaru wilgotności podłoża. Określamy zakres prac i dobieramy optymalną technologię hydroizolacji.",
    meta1: "CZAS: 90 MIN",
    meta2: "SPRZĘT: MIERNIK WILGOCI"
  }, {
    number: "02",
    title: "PRZYGOTOWANIE PODŁOŻA",
    description: "Mechaniczne oczyszczenie powierzchni z mchu, pyłu i luźnych fragmentów starej papy. Wykonujemy niezbędne naprawy ubytków, aby zapewnić idealną przyczepność nowej membrany natryskowej.",
    meta1: "CZAS: 120 MIN",
    meta2: "SPRZĘT: MYJKA CIŚNIENIOWA"
  }, {
    number: "03",
    title: "ZABEZPIECZENIE DETALI",
    description: "Uszczelnienie wszystkich newralgicznych punktów: kominów, świetlików, obróbek blacharskich oraz wpustów dachowych przy użyciu specjalistycznych mas uszczelniających i taśm zbrojących.",
    meta1: "CZAS: 180 MIN",
    meta2: "SPRZĘT: MASA POLIURETANOWA"
  }, {
    number: "04",
    title: "NATRYSK MEMBRANY",
    description: "Aplikacja bezspoinowej powłoki hydroizolacyjnej metodą natryskową. Tworzymy jednolitą, elastyczną warstwę, która całkowicie eliminuje ryzyko przecieków i jest odporna na promieniowanie UV.",
    meta1: "CZAS: 48 HRS",
    meta2: "SPRZĘT: AGREGAT NATRYSKOWY"
  }, {
    number: "05",
    title: "WARSTWA WYKOŃCZENIOWA",
    description: "Nałożenie powłoki ochronnej o wysokiej odporności mechanicznej i estetycznej. Zapewniamy trwałość na lata oraz doskonały wygląd dachu, który odbija promienie słoneczne.",
    meta1: "CZAS: 240 MIN",
    meta2: "SPRZĘT: SYSTEM NATRYSKOWY"
  }, {
    number: "06",
    title: "KONTROLA JAKOŚCI",
    description: "Końcowy odbiór techniczny, sprawdzenie szczelności oraz przekazanie dokumentacji powykonawczej. Gwarantujemy pełną ochronę Twojego obiektu przed warunkami atmosferycznymi.",
    meta1: "CZAS: 90 MIN",
    meta2: "SPRZĘT: PROTOKÓŁ ODBIORU"
  }];
  const {
    ref: lineRef,
    isVisible: lineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3787" id="proces-realizacji" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32 px-4 md:px-8">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "80px 80px"
    }} />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="text-center mb-16 md:mb-24">
          <div className="font-mono text-xs tracking-widest text-muted-foreground mb-6">
            [§ HYDRO-ROOF / METODOLOGIA]
          </div>
          <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05]">
            <span className="block">NASZ</span>
            <span className="block" style={{
            color: "var(--primary)"
          }}>
              PROFESJONALNY
            </span>
            <span className="block">PROCES</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-8 font-mono text-[10px] tracking-widest text-muted-foreground">
            <span className="h-px w-12 bg-border" />
            <span>06 ETAPÓW</span>
            <span className="h-px w-12 bg-border" />
          </div>
        </div>

        {}
        <div ref={lineRef} className="relative">
          {}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px md:-translate-x-1/2">
            <div className="absolute inset-0 bg-border" />
            <div className="absolute top-0 left-0 right-0 transition-all duration-[2500ms] ease-out" style={{
            height: lineVisible ? "100%" : "0%",
            backgroundColor: "var(--primary)",
            boxShadow: "0 0 8px var(--primary)"
          }} />
          </div>

          {}
          <div className="space-y-16 md:space-y-24">
            {steps.map((step, i) => {
            const isLeft = i % 2 === 0;
            return <StepItem key={i} data-index={i} step={step} isLeft={isLeft} index={i} />;
          })}
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28 flex items-center justify-center gap-3 font-mono text-[10px] md:text-xs tracking-widest text-muted-foreground">
          <span className="h-px flex-1 max-w-[120px] bg-border" />
          <span>[ KONIEC PROCESU — DACH ZABEZPIECZONY ]</span>
          <span className="h-px flex-1 max-w-[120px] bg-border" />
        </div>
      </div>
    </section>;
}
function StepItem({
  step,
  isLeft,
  index,
  ...rest
}: {
  step: {
    number: string;
    title: string;
    description: string;
    meta1: string;
    meta2: string;
  };
  isLeft: boolean;
  index: number;
  [key: string]: any;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const delay = `${index * 120}ms`;
  return <div ref={ref} className="relative grid md:grid-cols-2 md:gap-12 items-center" {...rest}>
      {}
      <div className="absolute left-6 md:left-1/2 -translate-x-1/2 z-10 flex items-center justify-center" style={{
      top: "1.5rem"
    }}>
        <div className="absolute size-4 rounded-lg opacity-30 animate-ping" style={{
        backgroundColor: "var(--primary)"
      }} />
        <div className="relative size-3 rounded-lg" style={{
        backgroundColor: "var(--primary)",
        boxShadow: "0 0 12px var(--primary)"
      }} />
      </div>

      {}
      <div className={`pl-16 md:pl-0 transition-all duration-700 ease-out ${isLeft ? "md:pr-12 md:text-right md:order-1" : "md:pl-12 md:order-2 md:col-start-2"}`} style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateX(0)" : `translateX(${isLeft ? "-40px" : "40px"})`,
      transitionDelay: delay
    }}>
        <div className={`font-mono text-xs tracking-widest text-muted-foreground mb-3 flex items-center gap-2 ${isLeft ? "md:justify-end" : "md:justify-start"}`}>
          <span className="h-px w-6 bg-border" />
          <span>ETAP</span>
        </div>

        <div className="font-default text-6xl md:text-7xl font-bold leading-none mb-4" style={{
        color: "var(--primary)"
      }}>
          {step.number}
        </div>

        <h3 className="font-default text-2xl md:text-[28px] font-semibold tracking-tight mb-4 text-foreground">
          {step.title}
        </h3>

        <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6 max-w-md md:max-w-none">
          {step.description}
        </p>

        <div className={`flex flex-col gap-1 font-mono text-[10px] md:text-xs tracking-widest text-muted-foreground ${isLeft ? "md:items-end" : "md:items-start"}`}>
          <div className="flex items-center gap-2">
            <span style={{
            color: "var(--primary)"
          }}>+</span>
            <span>{step.meta1}</span>
          </div>
          <div className="flex items-center gap-2">
            <span style={{
            color: "var(--primary)"
          }}>+</span>
            <span>{step.meta2}</span>
          </div>
        </div>
      </div>

      {}
      <div className={`hidden md:block ${isLeft ? "md:order-2" : "md:order-1 md:col-start-1 md:row-start-1"}`} />
    </div>;
}